define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var TranscoderInfo = (function () {
        function TranscoderInfo() {
            this.IsRunning = false;
        }
        return TranscoderInfo;
    }());
    exports.TranscoderInfo = TranscoderInfo;
});
//# sourceMappingURL=TrancoderInfo.js.map


//////////////////
// WEBPACK FOOTER
// ./wwwroot/js/Models/TrancoderInfo.js
// module id = 377
// module chunks = 0